<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md6>
          <!-- <v-btn   color='primary' @click="is_hafez = true; notes_manual =''">اضافة حافز       </v-btn>
                 <v-btn   color='red' @click="is_khasm = true; notes_manual =''">اضافة خصم       </v-btn>
                 <v-btn   color='yellow' @click="is_badalat = true; notes_manual =''">اضافة بدلات       </v-btn>
                 <v-btn   color='pink' @click="is_solfa = true; notes_manual =''">اضافة سلفة       </v-btn> -->
          <br />
          <br />
          <br />
          <br />
          <v-btn color="orange" @click="get_table"
            >أختر الشهر ثم اضغط لمعرفة تفاصيل المرتبات خلال هذا الشهر
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-date-picker
            v-model="picker"
            landscape
            type="month"
            color="green lighten-1"
          ></v-date-picker>
        </v-flex>
        <v-spacer></v-spacer>

        <!-- <v-flex xs12 sm6 md2>
        <v-dialog
          ref="dialog_from"
          v-model="modal_from"
          :return-value.sync="date_from"
          persistent
          lazy
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_from"
              label="تاريخ من"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date_from" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="modal_from = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.dialog_from.save(date_from)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
             </v-flex>
             <v-flex xs12 sm6 md2>
                  <v-dialog
          ref="dialog_to"
          v-model="modal_to"
          :return-value.sync="date_to"
          persistent
          lazy
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_to"
              label="تاريخ الي"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date_to" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="modal_to = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
             </v-flex> -->
        <v-dialog v-model="is_hafez" max-width="500px" dir="rtl" align="right">
          <v-card>
            <v-card-title>
              <span class="headline">اضافة حافز</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_employer_hafez"
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر الموظف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="hafez"
                        label=" الحافز"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-dialog
                        ref="dialog1"
                        v-model="modal1"
                        :return-value.sync="date1"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date1"
                            label=" التاريخ اليدوي"
                            readonly
                            outline
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date1" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            color="primary"
                            @click="$refs.dialog1.save(date1)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-textarea
                        v-model="notes_manual"
                        label=" الملاحظات"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="add_hafez()"
                >اضافة حافز</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="is_khasm" max-width="500px" dir="rtl" align="right">
          <v-card>
            <v-card-title>
              <span class="headline">اضافة خصم</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_employer_khasm"
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر الموظف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="khasm"
                        label=" الخصم"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3>
                      <v-dialog
                        ref="dialog2"
                        v-model="modal2"
                        :return-value.sync="date2"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date2"
                            label=" التاريخ اليدوي"
                            readonly
                            outline
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modal2 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            color="primary"
                            @click="$refs.dialog2.save(date2)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-textarea
                        v-model="notes_manual"
                        label=" الملاحظات"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="add_khasm()"
                >اضافة الخصم</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="is_badalat"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">اضافة بدلات</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_employer_badalat"
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر الموظف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="badalat"
                        label=" البدل"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md3>
                      <v-dialog
                        ref="dialog3"
                        v-model="modal3"
                        :return-value.sync="date3"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date3"
                            label=" التاريخ اليدوي"
                            readonly
                            outline
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date3" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modal3 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            color="primary"
                            @click="$refs.dialog3.save(date3)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-textarea
                        v-model="notes_manual"
                        label=" الملاحظات"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="add_badalat()"
                >اضافة بدل</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="is_solfa" max-width="500px" dir="rtl" align="right">
          <v-card>
            <v-card-title>
              <span class="headline">اضافة سلفة</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_employer_solfa"
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر الموظف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="solfa"
                        label=" السلفة"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-dialog
                        ref="dialog4"
                        v-model="modal4"
                        :return-value.sync="date4"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date4"
                            label=" التاريخ اليدوي"
                            readonly
                            outline
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date4" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click="modal4 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            color="primary"
                            @click="$refs.dialog4.save(date4)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-textarea
                        v-model="notes_manual"
                        label=" الملاحظات"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="add_solfa()"
                >اضافة سلفة</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-flex xs12 sm6 md2> جميع المرتبات : {{ all_salries }} </v-flex>

        <v-flex xs12 sm6 md2> جميع الحوافز : {{ all_hafezes }} </v-flex>

        <v-flex xs12 sm6 md2> جميع البدلات : {{ all_badalat }} </v-flex>

        <v-flex xs12 sm6 md2> جميع الخصومات : {{ all_khasms }} </v-flex>

        <v-flex xs12 sm6 md2> جميع السلف : {{ all_solfas }} </v-flex>

        <v-flex xs12 sm6 md2> صافي المرتبات : {{ all_cost }} </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-right">
            {{ props.item.employer ? props.item.employer.code : "" }}
          </td>
          <td class="text-xs-right">
            {{ props.item.employer ? props.item.employer.name : "" }}
          </td>
          <td class="text-xs-right">
            {{ props.item.employer ? props.item.employer.salary : "" }}
          </td>
          <td class="text-xs-right">{{ props.item.hafezes }}</td>
          <td class="text-xs-right">{{ props.item.badalats }}</td>
          <td class="text-xs-right">{{ props.item.khasms }}</td>
          <td class="text-xs-right">{{ props.item.solfas }}</td>
          <td class="text-xs-right">{{ props.item.cost }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير</div>
    </v-container>
  </div>
</template>

<script>
import {
  items,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  branches,
  khazina,
  employers_salary,
  employers,
  khazna_fatworas,
  add_hafez,
  add_khasm,
  add_badalat,
  add_solfa
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    picker: new Date().toISOString().substr(0, 7),
    date1: new Date().toISOString().substr(0, 10),
    modal1: false,
    date2: new Date().toISOString().substr(0, 10),
    modal2: false,
    date3: new Date().toISOString().substr(0, 10),
    modal3: false,
    date4: new Date().toISOString().substr(0, 10),
    modal4: false,
    month: "",
    year: "",
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " كود الموظف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم الموظف",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "  المرتب",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " الحوافز ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " البدلات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " الخصم ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " السلفة ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " صافي المرتب  ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    active: "",
    select_item: { id: "" },
    select_employer_solfa: { id: "" },
    select_employer_hafez: { id: "" },
    select_employer_khasm: { id: "" },
    select_employer_badalat: { id: "" },
    select_branch: { id: "" },
    search: "",
    comment: "",
    loading: true,
    hafez: "",
    khasm: "",
    badalat: "",
    solfa: "",
    is_hafez: false,
    is_khasm: false,
    is_badalat: false,
    is_solfa: false,
    khazina_fatworas: [],
    items: [],
    employers: [],
    fatworas: [],
    branches: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail: {},
    all_of_total: 0,
    count_of_count: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: "",
    notes_manual: "",
    all_cost: "",
    all_salries: "",
    all_hafezes: "",
    all_badalat: "",
    all_khasms: "",
    all_solfas: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return (parseFloat(total) * parseFloat(omola)) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      branches().then(response => {
        this.branches = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });

      this.month = this.picker.substr(5, 2);
      this.year = this.picker.substr(0, 4);
      var frmData = new FormData();
      frmData.append("month", this.month);
      frmData.append("year", this.year);
      employers_salary(frmData).then(response => {
        this.fatworas = response.data;
      });
      employers().then(response => {
        this.employers = response.data;
      });

      items().then(response => {
        this.items = response.data;
      });
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_item = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_item.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_item.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_item.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_branch.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    detailItem(order) {
      this.item_detail = order;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    get_table() {
      this.month = this.picker.substr(5, 2);
      this.year = this.picker.substr(0, 4);
      var frmData = new FormData();
      frmData.append("month", this.month);
      frmData.append("year", this.year);
      employers_salary(frmData).then(response => {
        this.fatworas = response.data.all_arr;
        this.all_cost = response.data.all_cost;
        this.all_salries = response.data.all_salries;
        this.all_hafezes = response.data.all_hafezes;
        this.all_badalat = response.data.all_badalat;
        this.all_khasms = response.data.all_khasms;
        this.all_solfas = response.data.all_solfas;
      });
    },
    add_hafez() {
      var frmData = new FormData();
      let month = new Date().toISOString().substr(5, 2);
      let year = new Date().toISOString().substr(0, 4);
      frmData.append("employer_id", this.select_employer_hafez.id);
      frmData.append("hafez", this.hafez);
      frmData.append("notes_manual", this.notes_manual);
      frmData.append("month", month);
      frmData.append("year", year);
      frmData.append("created_at", this.date1);
      if (this.select_employer_hafez.id != "" && this.hafez != "") {
        add_hafez(frmData).then(response => {
          this.$router.go(0);
        });
      }
    },
    add_khasm() {
      var frmData = new FormData();
      let month = new Date().toISOString().substr(5, 2);
      let year = new Date().toISOString().substr(0, 4);
      frmData.append("employer_id", this.select_employer_khasm.id);
      frmData.append("khasm", this.khasm);
      frmData.append("notes_manual", this.notes_manual);
      frmData.append("month", month);
      frmData.append("year", year);
      frmData.append("created_at", this.date2);
      if (this.select_employer_khasm.id != "" && this.khasm != "") {
        add_khasm(frmData).then(response => {
          this.$router.go(0);
        });
      }
    },
    add_badalat() {
      var frmData = new FormData();
      let month = new Date().toISOString().substr(5, 2);
      let year = new Date().toISOString().substr(0, 4);
      frmData.append("employer_id", this.select_employer_badalat.id);
      frmData.append("badalat", this.badalat);
      frmData.append("notes_manual", this.notes_manual);
      frmData.append("month", month);
      frmData.append("year", year);
      frmData.append("created_at", this.date3);
      if (this.select_employer_badalat.id != "" && this.badalat != "") {
        add_badalat(frmData).then(response => {
          this.$router.go(0);
        });
      }
    },
    add_solfa() {
      var frmData = new FormData();
      let month = new Date().toISOString().substr(5, 2);
      let year = new Date().toISOString().substr(0, 4);
      frmData.append("employer_id", this.select_employer_solfa.id);
      frmData.append("solfa", this.solfa);
      frmData.append("notes_manual", this.notes_manual);
      frmData.append("month", month);
      frmData.append("year", year);
      frmData.append("created_at", this.date4);
      if (this.select_employer_solfa.id != "" && this.solfa != "") {
        add_solfa(frmData).then(response => {
          this.$router.go(0);
        });
      }
    }
  }
};
</script>

<style scoped>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-date-picker-table--month td {
  height: 35px;
}
.v-picker__body {
  height: 196px;
}
.v-table__overflow {
  width: 1000px;
  margin-right: -85px;
}
</style>
